// This is useful so you don't have to make changes in several places when the provider
// changes their JS URL instructions on you
export const yotpoJsUrl = () =>
  `//staticw2.yotpo.com/${sl.api.yotpo.app_key}/widget.js`

// Use this to determine if you need to lazyload the external JS script
export const checkYotpoLoaded = () =>
  typeof yotpo !== "undefined" && typeof Yotpo !== "undefined"

// This function doesn't actually check if Yotpo is loaded, it's to set
// the initial value of yotpoLoaded for the React components properly when using refs
export const initialYotpoRefLoaded = () => !checkYotpoLoaded()

// Finally, this is the reload mechanism that you want to use within the ref
export const reloadYotpo = () => {
  if (checkYotpoLoaded()) {
    // Never trust external code, so a try-catch will be useful here to avoid React crashes
    try {
      // eslint-disable-next-line no-undef
      const api = new Yotpo.API(yotpo)
      api.refreshWidgets()
    } catch (e) {
      console.log("Yotpo threw error", e)
    }
  }
}
